/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown>, name: NonNullable<unknown> }} Agent_Access_Label_ConnectionInputs */



/**
* | output |
* | --- |
* | "{provider} connection \"{name}\"" |
*
* @param {Agent_Access_Label_ConnectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_label_connection = /** @type {((inputs: Agent_Access_Label_ConnectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Label_ConnectionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.provider}-Verbindung „${i?.name}“`)
	return /** @type {LocalizedString} */ (`${i?.provider} connection "${i?.name}"`)
});